import React from 'react';
import Typography from '@material-ui/core/Typography';

const Unauthorized = () => {
  return (
      <Typography variant={'h3'}>
        Sorry, you do not have access to this page.
      </Typography>
  )
}

export default Unauthorized;